var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm.profile.name
      ? _c("p", [
          _c("strong", [_vm._v("Name:")]),
          _vm._v(
            " " +
              _vm._s(_vm.profile.title) +
              " " +
              _vm._s(_vm.profile.name) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "headline" }, [
      _c("img", { attrs: { src: require("../../assets/dog-profile.jpeg") } }),
      _c("h1", [_vm._v("Your doge profilesx")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }